import { render, staticRenderFns } from "./ChargeRejectDialog.vue?vue&type=template&id=4855184a&scoped=true"
import script from "./ChargeRejectDialog.vue?vue&type=script&lang=js"
export * from "./ChargeRejectDialog.vue?vue&type=script&lang=js"
import style0 from "./ChargeRejectDialog.vue?vue&type=style&index=0&id=4855184a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855184a",
  null
  
)

export default component.exports